import MAKE_CALL from '@/graphql/mutations/MakeCall.gql'
import GraphQLHelper from '@/helpers/GraphQLHelper'

const _graphQlHelper = new GraphQLHelper()

export default async (self, phone) => {
  await self.$apollo.mutate({
    mutation: MAKE_CALL,
    variables: {
      phone
    }
  }).catch(error => {
    _graphQlHelper.graphQLErrorMessages(error).forEach(item => {
      self.$notify({
        group: 'lsg-notify',
        text: item
      })
    })
  })
}
